import { SpaceTypes } from 'src/models/enums/spaceTypes.enum';
import { Workspace } from 'src/models/workspace.interface';
import axiosCore from 'src/utils/axiosCore';

import { APIResponse } from './APIResponse';
import { prepareAxiosError } from './handleApiAxiosError';

export const getSpacesApi = async () => {
  try {
    const {
      data: { data, message }
    } = await axiosCore.get<
      APIResponse<
        (Pick<Workspace, '_id' | 'name' | 'images' | 'description'> & {
          type: SpaceTypes;
        })[]
      >
    >(`/workspace/spaces`);

    return { data, message };
  } catch (error) {
    throw prepareAxiosError(error);
  }
};
